var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "Parallax",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Parallax.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-a7c9e2b2!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./Parallax.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/parallax/Parallax.vue
// module id = 103
// module chunks = 0